<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ fullName }}
        </p>
        <span class="user-status">
          {{ userRol.nombre }}
          <span v-if="matricula">
            -
            Matrícula: <strong>{{ matricula }}</strong>
          </span>
        </span>
      </div>
      <b-avatar
        size="40"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>

    <b-dropdown-item
      :to="{ name: 'usuario-perfil'}"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>Perfil</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'alumno-aprendizaje' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="AwardIcon"
        class="mr-50"
      />
      <span>Mi aprendizaje</span>
    </b-dropdown-item>
    <!-- <b-dropdown-item
      :to="{ name: 'alumno-compras' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="CreditCardIcon"
        class="mr-50"
      />
      <span>Mis compras</span>
    </b-dropdown-item> -->
    <b-dropdown-divider />
    <b-dropdown-item
      :to="{ name: 'compras-list', params: { id: '1' } }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="ShoppingBagIcon"
        class="mr-50"
      />
      <span>Mis solicitudes</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'usuario-cuenta' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="SettingsIcon"
        class="mr-50"
      />
      <span>Mi cuenta</span>
    </b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item
      v-show="false"
      :to="{ name: 'public-ayuda' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="HelpCircleIcon"
        class="mr-50"
      />
      <span>Ayuda</span>
    </b-dropdown-item>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="closeSession()"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>Salir</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
// import { initialAbility } from '@/libs/acl/config'
// import useJwt from '@/auth/jwt/useJwt'
// import { avatarText } from '@core/utils/filter'
import {
  computed,
} from '@vue/composition-api'
import store from '@/store/index'
// import { logout } from '@/auth/utils'
import { closeAccount } from '@core/mixins/account-data/account'
import { rolesActions } from '@core/mixins/account-data/roles'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  // methods: {
  //   logout() {
  //     // Remove userData from localStorage
  //     // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
  //     localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
  //     localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

  //     // Remove userData from localStorage
  //     localStorage.removeItem('userData')

  //     // Reset ability
  //     this.$ability.update(initialAbility)

  //     // Redirect to login page
  //     this.$router.push({ name: 'auth-login' })
  //   },
  // },
  mixins: [closeAccount, rolesActions],
  setup() {
    // const { cleanUserData } = logout()
    // Method ready to be called, clean the user's data
    // const closeSession = () => { cleanUserData() }
    // const closeSession = () => {
    //   // loader.value.general = true // Start general loader - change ref value (loader.general)
    //   cleanUserData()
    // }

    // Computed propieties
    const fullName = computed(() => store.getters['cuenta/getFullName'])
    const matricula = computed(() => store.state.cuenta.info.matricula ?? null)

    return {
      fullName,
      matricula,
      // userRol,
      // closeSession,
    }
  },
}
</script>
